import React from 'react';
import styled from 'styled-components';
import { DefaultPalette, Slider, Stack, IStackStyles, IStackTokens } from '@fluentui/react';
import { ResponsiveBullet } from '@nivo/bullet'

const itemStyles = {
    alignItems: 'center',
    background: '#f2f2f2',
    height: '700px',
    width: '600px',
    justifyContent: 'center',
};

const stackStyles = {
    root: {
        width: `100%`
    },
};

const stackWrapperStyles = {
    backgroundColor: `#000000`,
    height: `100vh`
};

const Title = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
`;

const data = [
    {
        "id": "1.สิ่งที่ดึงดูดใจทางการท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "2.การเข้าถึงแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            90
        ]
    },
    {
        "id": "3.สิ่งอำนวยความสะดวกในแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "4.การบริหารจัดการแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "5.ที่พักในแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "6.กิจกรรมการท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "7.ความปลอดภัยในแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "8.การประชาสัมพันธ์แหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "9.ทัศนียภาพแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
    {
        "id": "10.การบริหารจัดการด้านสิ่งแวดล้อมของแหล่งท่องเที่ยว",
        "ranges": [
            20,
            40,
            60,
            80,
            100
        ],
        "measures": [
            0
        ],
        "markers": [
            70
        ]
    },
];

const colors = { 'ซื้ออาหารทะเล': '#93db97', 'รับประทานอาหาร (อาหารทะเล / ก๋วยเตี๋ยว)': '#93db97', 'พักผ่อน / ท่องเที่ยว': '#93db97' }
const getColor = bar => colors[bar.id]

// Tokens definition
const sectionStackTokens = { childrenGap: 10 };
const wrapStackTokens = { childrenGap: 10 };


class Rate extends React.Component {

    render() {
        return (
            <span style={itemStyles}>
                <Title>ระดับความพึงพอใจของนักท่องเที่ยวต่อแหล่งท่องเที่ยวพื้นที่นาเกลือ</Title>
                <ResponsiveBullet
                    data={data}
                    margin={{ top: 25, right: 40, bottom: 90, left: 280 }}
                    spacing={46}
                    titleAlign="start"
                    titleOffsetX={-265}
                    markerColors={["black"]}
                    measureSize={0.2}
                    markerSize={0.7}
                    rangeColors={["#C1252C", "#DC5D27", "#F79321", "#8CA349", "#21B472"]}
                />
            </span>
        );
    }
}

export default Rate;